import { derived, writable } from 'svelte/store';

import {
	NAVIGATION_KEY,
	parseNavigation,
	isDesktopMac,
	resolveNavigation,
	type NavigationPreference
} from './navigationMath';
export * from './navigationMath';

export const navigationPreference = writable<NavigationPreference>('auto', (set) => {
	if (typeof window === 'undefined') return;
	try {
		set(parseNavigation(localStorage.getItem(NAVIGATION_KEY)));
	} catch {
		/* Memory-only preferences. */
	}
	const update = (event: StorageEvent): void => {
		if (event.key === NAVIGATION_KEY || event.key === null) set(parseNavigation(event.newValue));
	};
	window.addEventListener('storage', update);
	return () => window.removeEventListener('storage', update);
});

export const navigation = derived(navigationPreference, (preference) => {
	const nav: (Navigator & { userAgentData?: { platform: string; mobile: boolean } }) | null =
		typeof navigator === 'undefined' ? null : navigator;
	const mac: boolean =
		nav !== null &&
		isDesktopMac(
			// Client hints can exist with an empty platform, notably after a
			// browser automation override. Fall back just as when hints are absent.
			nav.userAgentData?.platform || nav.platform,
			nav.maxTouchPoints,
			nav.userAgentData?.mobile
		);
	return { preference, mac, mode: resolveNavigation(preference, mac) };
});

export function setNavigation(preference: NavigationPreference): void {
	navigationPreference.set(preference);
	try {
		localStorage.setItem(NAVIGATION_KEY, preference);
	} catch {
		/* Memory-only preferences. */
	}
}
